/* eslint-disable */
import {MultiPolygon, Polygon} from "ol/geom";
import {Feature} from "ol";
import {Fill, Stroke, Style, Text} from "ol/style";

export const initializeMapBoundary = (map, boundary, userMap) => {
    let boundaryVectorSource

    map.getLayers().forEach((layer) => {
        if (layer.getSource().get('name') === 'map') boundaryVectorSource = layer.getSource()
    })

    boundary.forEach((geo) => {

        const type = geo.geometry.type;
        let geometry;
        if (type === "Polygon") {
            geometry = new Polygon(geo.geometry.coordinates);
        } else if (type === "MultiPolygon") {
            geometry = new MultiPolygon(geo.geometry.coordinates);
        }

        geometry.transform("EPSG:4326", "EPSG:3857");

        const feature = new Feature({
            geometry: geometry,
            name: geo.properties.name ?? "",
            id: geo.id
        });

        feature.setStyle(
            new Style({
                stroke: new Stroke({
                    color: "#585B5C",
                    width: 1
                }),
                text: new Text({
                    font: 'bold 12px Roboto,sans-serif',
                    fill: new Fill({ color: '#000' }),
                    text: feature.get('name'),
                })
            })
        );

        boundaryVectorSource.addFeature(feature);
    })

    const extent = boundaryVectorSource.getExtent();
    map.getView().fit(extent, { padding: [100, 100, 100, 100] });

    // TODO: Временное решение для центрирование карт на границах.
    const badCenterList = {
        'Россия': [10050449.354211085, 10784666.888773263],
        'Russia': [10050449.354211085, 10784666.888773263],
        'США': [-14283960.461138923, 7103282.803790733],
        'United States': [-14283960.461138923, 7103282.803790733],
        'Аляска': [-16976500.64470121, 9632603.609010197],
        'Alaska': [-16976500.64470121, 9632603.609010197],
        'Чукотский АО': [19278828.034086112, 10090823.459625918],
        'Chukot': [19278828.034086112, 10090823.459625918]
    }

    if (badCenterList[userMap.name]) {
        map.getView().setCenter(badCenterList[userMap.name])
    }
}

function getCenterOfExtent(Extent){
    const X = Extent[0] + (Extent[2] - Extent[0]) / 2;
    const Y = Extent[1] + (Extent[3] - Extent[1]) / 2;
    return [X, Y];
}